import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { PathBuilder, RequestTypes, axiosBaseQuery } from '../../utils';
import {
 IMessageResponse,
 credential,
 ISubscriptionPlanResponse,
 ISubscriptionPlanQuery,
 ISubscriptionPlan,
 ISubscriptionPlanDTO,
} from '../../shared';
import { ReducerKeys } from '../types';

export const subscriptionPlansApi = createApi({
 reducerPath: ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY,
 baseQuery: axiosBaseQuery({
  baseUrl: credential.apiUrl as string,
 }),
 tagTypes: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
 endpoints: (build) => ({
  fetchPlanList: build.query<ISubscriptionPlanResponse, ISubscriptionPlanQuery>(
   {
    query: (params) => ({
     url: PathBuilder.subscriptionPlansApi.fetchPlanList(),
     method: RequestTypes.get,
     params,
    }),
    providesTags: () => [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
   }
  ),
  createPlan: build.mutation<
   ISubscriptionPlan,
   {
    title: string;
    numberOfSessions: number;
   }
  >({
   query: (body) => ({
    url: PathBuilder.subscriptionPlansApi.createPlan(),
    method: RequestTypes.post,
    headers: {
     'Content-Type': 'application/json',
    },
    data: body,
   }),
   invalidatesTags: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),
  fetchPlan: build.query<ISubscriptionPlan, string>({
   query: (id) => ({
    url: PathBuilder.subscriptionPlansApi.fetchPlan(id),
    method: RequestTypes.get,
   }),
   providesTags: () => [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),
  updatePlan: build.mutation<
   ISubscriptionPlan,
   { body: ISubscriptionPlanDTO; id: string }
  >({
   query: (data) => {
    const { body, id } = data;

    return {
     url: PathBuilder.subscriptionPlansApi.updatePlan(id),
     method: RequestTypes.put,
     headers: {
      'Content-Type': 'application/json',
     },
     data: body,
    };
   },
   invalidatesTags: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),
  deletePlan: build.mutation<IMessageResponse, string>({
   query: (id) => ({
    url: PathBuilder.subscriptionPlansApi.deletePlan(id),
    method: RequestTypes.delete,
   }),
   invalidatesTags: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),

  activatePlan: build.mutation<ISubscriptionPlan, string>({
   query: (id) => ({
    url: PathBuilder.subscriptionPlansApi.activatePlan(id),
    method: RequestTypes.patch,
   }),
   invalidatesTags: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),
  deactivatePlan: build.mutation<ISubscriptionPlan, string>({
   query: (id) => ({
    url: PathBuilder.subscriptionPlansApi.deactivatePlan(id),
    method: RequestTypes.patch,
   }),
   invalidatesTags: [ReducerKeys.SUBSCRIPTION_PLANS_API_REDUCER_KEY],
  }),
 }),
});
